import React from 'react';
import { VSLSection } from '../components/VSLSection';
export function VSLPage() {
  return <main className="min-h-screen bg-navy font-sans text-cream selection:bg-terracotta/30 selection:text-navy" data-id="element-267">
      <VSLSection data-id="element-268" />
    </main>;
}